import requests from "./httpService";

const LanguageDriverServices = {

  addLanguageDriver: async (body) => {
    return requests.post(`/language/add/`, body);
  },
  getAllLanguageDriver: async () => {
    return requests.get(`/language/`);
  },
  getLanguageDriverById: async (id) => {
    return requests.get(`/language/${id}`);
  },

  updateLanguageDriver: async (id, body) => {
    return requests.put(`/language/update/${id}`, body);
  },

  deleteLanguageDriver: async (id) => {
    return requests.delete(`/language/delete/${id}`);
  },
  updateActiveStatus:async(id,body) =>{
    return requests.post(`/language/status/${id}`, body);
  },
 
};

export default LanguageDriverServices;
